import { httpClient } from "../http/httpClient";

interface ManualWithdrawPayload {
  amount: number;
  user: string;
  status: "UNPAID" | "PENDING" | "PAID";
}

export const ManuallyWithdraw = async (payload: ManualWithdrawPayload) => {
  const response = await httpClient
    .post("/withdraw/manual", payload)
    .catch((error) => {
      throw error.response?.data || error;
    });
  return response.data;
};
